import React from 'react';
import '@components/module-components/logo/logo.scss';

interface ILogo {
  logo: string,
  url: string
}

const Logo = ({logo, url}: ILogo) => {
  return url ?
          <a href={url} className="logo"><img src={logo} alt=""/></a> :
          <div className="logo"><img src={logo} alt=""/></div>
  ;
}

export default Logo;
